import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { PolicyCheckbox } from "@/components/PolicyCheckbox/PolicyCheckbox";
import { Button } from "@/components/Button";
import { NameInput } from "@/components/Inputs/NameInput";
import { PhoneInput } from "@/components/Inputs/PhoneInput";
import { EmailInput } from "@/components/Inputs/EmailInput";
import styles from "./PersonalTrainingForm.module.scss";
import { ValidMessages } from "@/resources/locale";
import { sendPersonalTrainingOrder } from "@/redux/training/asyncActions";
import { useAppDispatch } from "@/redux/store";

export const PersonalTrainingForm = () => {
  const dispatch = useAppDispatch();

  const initialValues = {
    name: "",
    phone: "",
    email: "",
    acceptTerms: false,
  };

  const validationSchema = Yup.object({
    name: Yup.string()
      .required(ValidMessages.inputs.name.REQUIRED),
    phone: Yup.string()
      .min(16, ValidMessages.inputs.phone.NOT_FULL)
      .required(ValidMessages.inputs.phone.REQUIRED),
    email: Yup.string()
      .email(ValidMessages.inputs.email.INCORRECT)
      .required(ValidMessages.inputs.email.REQUIRED),
    acceptTerms: Yup.boolean()
      .required(ValidMessages.inputs.acceptPersonalData.REQUIRED),
  });

  const handleSubmit = (values: any) => {
    const data = {
      full_name: values.name,
      phone: values.phone.replace(/[-()\s]/g, ""),
      email: values.email,
    }

    dispatch(sendPersonalTrainingOrder(data));
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formik) => {
        return (
          <Form className={styles.form}>
            <div className={styles.formSection}>
              <NameInput name="name" lable="ФИО" placeholder="Иванов Иван" />
              <ErrorMessage component="div" className={styles.errorMessage} name="name" />
            </div>
            
            <div className={styles.formSection}>
              <PhoneInput name="phone" lable="Номер телефона" placeholder="+7 (___) ___-__-__" />
              <ErrorMessage component="div" className={styles.errorMessage} name="phone" />
            </div>
            
            <div className={styles.formSection}>
              <EmailInput name="email" lable="Email" placeholder="example@example.com" />
              <ErrorMessage component="div" className={styles.errorMessage} name="email" />
            </div>

            <PolicyCheckbox formik={formik} />

            <Button
              type="submit"
              disabled={!formik.values.acceptTerms || !formik.values.name || !formik.values.phone || !formik.values.email || !formik.isValid}
              newStyles={styles.button}
            >
              Оставить заявку
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};